import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AppComponent } from './app.component';
import { RequestComponent } from './request/request.component';
import { ResponseComponent } from './response/response.component';

import { ErnstWebService } from './request/ernstweb.service';
import { ResponseService } from './response/shared/response.service';
import { LocationComponent } from './location/location.component';
import { LoanComponent } from './loan/loan.component';
import { InspectionsComponent } from './inspections/inspections.component';
import { RequestService } from './request/shared/request.service';
import { GovermentFeesComponent } from './response/goverment-fees.component';
import { TitleFeesComponent } from './response/title-fees.component';
import { InspectionFeesComponent } from './response/inspection-fees.component';
import { PropertytaxComponent } from './response/propertytax.component';
import { ClientTokenService } from './clienttoken.service';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [
    AppComponent,
    RequestComponent,
    ResponseComponent,
    LocationComponent,
    LoanComponent,
    InspectionsComponent,
    GovermentFeesComponent,
    TitleFeesComponent,
    InspectionFeesComponent,
    PropertytaxComponent
  ],
  imports: [
    NgbModule.forRoot(),
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    ReactiveFormsModule,
    AppRoutingModule,
    FontAwesomeModule
  ],
  providers: [
    ClientTokenService,
    ErnstWebService,
    ResponseService,
    RequestService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
